<template>
  <div>
    <v-row>
      <v-col>
        <div class="pt-3">
          <h4>Historial Académico de {{ user.apellido }}, {{ user.nombre }}</h4>
          <div class="subtitle-2">DNi: {{ user.dni }}</div>
          <div class="subtitle-2">Email: {{ user.email }}</div>
          <div class="subtitle-2">Telefono: {{ user.telefono }}</div>
          <span class="subtitle-2">
            Carreras:
            <span v-for="(carrera, i) in user.carreras" :key="carrera.id"
              >{{ carrera.nombre }} {{ i > 0 ? "," : "" }}</span
            ></span
          >
        </div>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <template v-if="tieneCarrerasHabilitadas">
      <v-row class="mt-3">
        <v-col cols="12" md="6">
          <v-select
            v-model="carreraSeleccionada"
            :items="carrerasUsuarioHabilitadas"
            item-text="nombre"
            item-value="id"
            label="Seleccione una carrera"
            outlined
            dense
          ></v-select>
        </v-col>
      </v-row>

      <v-tabs color="white" v-model="tab" background-color="teal">
        <v-tab> Cursados </v-tab>
        <v-tab> Examenes </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <alumno-historial-cursado-por-a-lumno-a-b-m
            ref="historialCursado"
            :alumno_id="user.id"
            :carrera_id="carreraSeleccionada"
          ></alumno-historial-cursado-por-a-lumno-a-b-m>
        </v-tab-item>
        <v-tab-item>
          <alumno-historial-examen-por-a-lumno-a-b-m
            ref="historialExamen"
            :alumno_id="user.id"
            :carrera_id="carreraSeleccionada"
          ></alumno-historial-examen-por-a-lumno-a-b-m>
        </v-tab-item>
      </v-tabs-items>
    </template>

    <v-alert v-else type="info" class="mt-4">
      El historial académico aún no está habilitado.
    </v-alert>
  </div>
</template>

<script>
// import { mapActions, mapState } from "vuex";
import AlumnoHistorialExamenPorALumnoABM from "@/flavor/alumno/views/historial-examen-por-alumno/AlumnoHistorialExamenPorALumnoABM.vue";
import AlumnoHistorialCursadoPorALumnoABM from "@/flavor/alumno/views/historial-cursado-por-alumno/AlumnoHistorialCursadoPorALumnoABM.vue";
// import {mapActions, mapState} from "vuex";

export default {
  name: "AlumnoHistorialAcademicoPorAlumno",
  components: {
    AlumnoHistorialExamenPorALumnoABM,
    AlumnoHistorialCursadoPorALumnoABM,
  },
  // props: {
  //   alumno_id: [String, Number],
  // },
  data() {
    return {
      tab: {},
      user: {},
      carrerasHabilitadas: [
        // 1, //PEI
        // 2, // GUAR viejo
        // 3, //PEP
        // 4, //TSAE
        // 5, // PESB
        // 6, //ALIL
        // 7, //AEJ
        // 8, //GUAR23
        // 9, //TSG
        // 10, //TSG2025
        11, //TSH
        12, // coordinador
      ], // IDs de las carreras habilitadas
      carreraSeleccionada: null,
    };
  },
  computed: {
    tieneCarrerasHabilitadas() {
      if (!this.user.carreras || this.user.carreras.length === 0) {
        return false;
      }
      // Verificar si el usuario tiene alguna carrera habilitada
      return this.user.carreras.some((carrera) =>
        this.carrerasHabilitadas.includes(carrera.id)
      );
    },
    carrerasUsuarioHabilitadas() {
      if (!this.user.carreras) return [];
      // Filtrar solo las carreras habilitadas del usuario
      return this.user.carreras.filter((carrera) =>
        this.carrerasHabilitadas.includes(carrera.id)
      );
    },
    // ...mapState("CarreraModule",["carreras"])
    // ...mapState("NewUserModule", ["user"]),
  },
  methods: {
    //   ...mapActions("NewUserModule", ["getUser"]),
    //   ...mapActions("CarreraModule",["getCarreras"])
  },
  watch: {
    carreraSeleccionada(newVal, oldVal) {
      if (newVal !== oldVal && oldVal !== null) {
        // Ejecutar reload en ambos componentes cuando cambie la carrera
        this.$nextTick(() => {
          if (
            this.$refs.historialCursado &&
            this.$refs.historialCursado.reload
          ) {
            this.$refs.historialCursado.reload();
          }
          if (this.$refs.historialExamen && this.$refs.historialExamen.reload) {
            this.$refs.historialExamen.reload();
          }
        });
      }
    },
  },
  created() {
    this.user = this.$attrs["user"];
    // Seleccionar automáticamente la primera carrera habilitada
    if (this.carrerasUsuarioHabilitadas.length > 0) {
      this.carreraSeleccionada = this.carrerasUsuarioHabilitadas[0].id;
    }
    // this.getCarreras();
    // this.getUser();
    // this.alumno_id = this.user.id;
  },
};
</script>

<style scoped></style>
